import { render, useState, useEffect, useRef } from "@wordpress/element";
import axios from "axios";
import MingButton from "../../editor/components/mingButton/MingButton";
import Spinner from "../../editor/components/spinner/Spinner";

const {
  journal_archive_selected_journal: journals,
  journal_archive_fetch_number: perPage,
  journal_archive_no_journal_text: noMoreText,
} = translationString;

const App = () => {
  const [journalsList, setjournalList] = useState([]);
  const [noMore, setNoMore] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [init, setInit] = useState(true);
  const formBoxRef = useRef(null);

  useEffect(() => {
    const journalsId = journals.map((journal) => journal.id);
    const endpoint =
      "/wp-json/wp/v2/journal?include=" +
      journalsId.join(",") +
      "&orderby=include";
    axios.get(endpoint).then((res) => {
      setjournalList([...journalsList, ...res.data]);
      setIsLoading(false);
      setInit(false);
    });
  }, []);

  useEffect(() => {
    const isElementInViewport = (el) => {
      const rect = el.getBoundingClientRect();

      return (
        rect.top <=
        (window.innerHeight || document.documentElement.clientHeight)
      );
    };

    formBoxRef.current = document.getElementById("archive__formbox");

    const scrollFetch = () => {
      if (
        isElementInViewport(formBoxRef.current) &&
        isLoading === false &&
        init === false &&
        noMore === false
      ) {
        fetchMore();
      }
    };

    window.addEventListener("scroll", scrollFetch);

    return () => {
      window.removeEventListener("scroll", scrollFetch);
    };
  }, [isLoading, init, formBoxRef]);

  const fetchMore = () => {
    setIsLoading(true);
    const exclude = journalsList.map((journal) => journal.id);
    const endpoint =
      "/wp-json/wp/v2/journal?exclude=" +
      exclude.join(",") +
      "&per_page=" +
      perPage;
    axios.get(endpoint).then((res) => {
      if (res.data.length === 0) {
        setNoMore(true);
        setIsLoading(false);
        return;
      }

      setjournalList([...journalsList, ...res.data]);
      setIsLoading(false);
    });
  };

  if (isLoading && init) {
    return (
      <ul className="archive__loadMoreContainer">
        <Spinner />
      </ul>
    );
  }
  //   <a class="journalsList__card" href="${res.link}">
  //   <div class="journalsList__infoContainer" style="background-image: url('${res.better_featured_image?.source_url}');">
  //     <span class="journalsList__infoWrapper">
  //       <span class="journalsList__clientNameContainer">
  //         <span class="journalsList__clientName">${res.meta.work_client_name}</span>
  //       </span>
  //       <span class="journalsList__titleContainer">
  //       </span>
  //       <span class="journalsList__knowMoreContainer">
  //       </span>
  //     </span>
  //   </div>
  //   <div>
  //     <div class="journalsList__textContainer">
  //       <h3>${res.title.rendered}</h3>
  //     </div>
  //   </div>
  // </a>
  return (
    <ul className="journalsList__wrapper">
      {journalsList.map((journal, index) => (
        <li className="journalsList__item">
          <a className="journalsList__card" href={journal.link}>
            <div
              class="journalsList__infoContainer"
              style={{
                backgroundImage: `url('${journal.better_featured_image.source_url}')`,
              }}
            >
              <span class="journalsList__infoWrapper">
                <span class="journalsList__clientNameContainer">
                  <span class="journalsList__clientName">
                    {journal.meta.journal_client_name}
                  </span>
                </span>
                <span class="journalsList__titleContainer"></span>
                <span class="journalsList__knowMoreContainer"></span>
              </span>
            </div>
            <div>
              <div class="journalsList__textContainer">
                <h3>{journal.title.rendered}</h3>
              </div>
            </div>
          </a>
        </li>
      ))}
      <div className="archive__loadMoreContainer">
        {isLoading && <Spinner />}
      </div>
    </ul>
  );
};

render(<App />, document.querySelector(".journalsList"));
